'use es6';

import { ACCESS_CONTROL } from './accessControl';
export const getHasScopeSplitAccess = () => ACCESS_CONTROL.SCOPE_SPLIT;